import {useTranslation} from 'react-i18next'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {EntrevistaTranscriptView} from '@/components/entrevista-transcript-view'
import {useEmployeeEntrevista} from '@/hooks/sgsst/riesgos/use-entrevista'

/** Solo la entrevista vigente; las versiones anteriores viven en el historial de la ficha. */
export function EntrevistaTranscriptDialog({
  businessId,
  employee,
  onClose,
}: {
  businessId: string
  employee: {id: string; name: string; last_name: string} | null
  onClose: () => void
}) {
  const {t} = useTranslation()
  const {data: entrevista, isLoading} = useEmployeeEntrevista(businessId, employee?.id)

  return (
    <Dialog open={!!employee} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-lg" data-testid="entrevista-transcript-dialog">
        <DialogHeader>
          <DialogTitle>
            {employee && t('employees.transcript.title', {name: `${employee.name} ${employee.last_name}`})}
          </DialogTitle>
        </DialogHeader>
        <EntrevistaTranscriptView
          businessId={businessId}
          employeeId={employee?.id}
          entrevista={entrevista}
          isLoading={isLoading}
        />
      </DialogContent>
    </Dialog>
  )
}
